export enum AccountType {
    Bg = 'Bankgiro',
    Pg = 'Plusgiro',
}
